export default __webpack_public_path__ + "static/blog2-c616288bbc2d4d4fc89c4dc8c101bc81.jpeg";